import { Icon, IconProps } from './Icon';

interface AddEmailIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const AddEmailIcon = ({ color = '#5E6A81', gradient, ...props }: AddEmailIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 25 24"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      d="M15.6651 6.46094H5.81896C5.16612 6.46094 4.54002 6.72028 4.07839 7.18191C3.61676 7.64353 3.35742 8.26964 3.35742 8.92248V17.5379C3.35742 18.1907 3.61676 18.8168 4.07839 19.2784C4.54002 19.7401 5.16612 19.9994 5.81896 19.9994H18.1267C18.7795 19.9994 19.4056 19.7401 19.8672 19.2784C20.3289 18.8168 20.5882 18.1907 20.5882 17.5379V11.384"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.81934 10.1538L11.9732 13.8462L18.127 10.1538M20.5886 4V8.92308M18.127 6.46154H23.0501"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
